import React from 'react';
import {useTalon, UseTalonProps} from '../hooks';

export interface WithTalonProps {
    talon: UseTalonProps;
}

function withTalon<TProps, TRef = HTMLElement>(
    WrappedComponent: React.ComponentType<TProps & WithTalonProps>
) {
    const forwardedComponent = React.forwardRef<TRef, TProps>((props, ref) => {
        const talon = useTalon();
        return <WrappedComponent ref={ref} {...props} talon={talon} />;
    });

    forwardedComponent.displayName = `withTalon(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        'Component'})`;

    return forwardedComponent;
}

export default withTalon;
